import { useEffect } from 'react'
import { useRouter } from 'next/router'
import { setCookie } from 'cookies-next'


const NINETY_DAYS = 60 * 60 * 24 * 90

const UTM_KEYS = [
  'utm_source',
  'utm_medium',
  'utm_campaign',
  'utm_content',
  'utm_term'
] as const


const parseUrlParams = ({
  router
}: {
  router: ReturnType<typeof useRouter>
}): Record<string, string> | undefined => {
  // console.log('!!!!!!!!', router)
  const params = router.asPath.split('?')[1]

  if (params)
    return params.split('&').reduce(
      (acc, cur) => ({
        ...acc,
        [cur.split('=')[0] as string]: cur.split('=')[1]
      }),
      {}
    )

  return undefined
}

export const useHandleUtms = () => {
  const router = useRouter()
  const params = parseUrlParams({ router })

  useEffect(() => {
    if (params)
      UTM_KEYS.forEach(utmKey =>
        params[utmKey]
          ? setCookie(utmKey, params[utmKey], { maxAge: NINETY_DAYS })
          : undefined
      )
  }, [params])
}
